import { RoomSummaryContext } from "@fidget/common/models/chat/roomSummaryContext";
import { Instance, types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

export const RoomSummaryChatItem = types.compose(
  "RoomSummaryChatItem",
  BaseChatItem,
  types.model({
    type: types.literal(ChatItemType.RoomSummary),
    context: types.frozen<RoomSummaryContext>()
  })
);

export interface IRoomSummaryChatItem extends Instance<typeof RoomSummaryChatItem> {}
